// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const configurazione = {
  iva: 0.22,
  istanzaorfri: 6,
  azienda: {
    fb: {
      Codice: 'none',
      Attivo: 'none',
      Nome: '',
      Partitaiva: '',
      Missione: 'none',
      Codicefiscale: '',
      Ragionesociale: '',
      Attivita: '',
      Numerodipendenti: '',
      Rea: 'none',
      Datarea: 'none',
      Cameracommercio: 'none',
      Email: '',
      Pec: '',
      Telefono: 'none',
      Cellulare: 'none',
      Svi: 'none',
      customdata: 'none',
      },
    orfri: {
      Codice: 'none',
      Attivo: 'none',
      Nome: '',
      Partitaiva: '',
      Missione: 'none',
      Codicefiscale: '',
      Ragionesociale: '',
      Attivita: 'none',
      Numerodipendenti: 'none',
      Rea: 'none',
      Datarea: 'none',
      Cameracommercio: 'none',
      Email: '',
      Pec: '',
      Telefono: '',
      Cellulare: '',
      Svi: '',
      customdata: '',
    }
  },

  addazienda: {
    fb: {
      Codice: 'none',
      Nome: '',
      Partitaiva: '',
      Missione: 'none',
      Codicefiscale: '',
      Ragionesociale: '',
      Attivita: '',
      Numerodipendenti: '',
      Rea: 'none',
      Datarea: 'none',
      Cameracommercio: 'none',
      Email: '',
      Pec: '',
      Telefono: 'none',
      Cellulare: 'none',
      Svi: 'none',
      Attivo: 'none',
      },
    orfri: {
        Codice: 'none',
        Nome: '',
        Partitaiva: '',
        Missione: 'none',
        Codicefiscale: '',
        Ragionesociale: '',
        Attivita: 'none',
        Numerodipendenti: 'none',
        Rea: 'none',
        Datarea: 'none',
        Cameracommercio: 'none',
        Email: '',
        Pec: '',
        Telefono: '',
        Cellulare: '',
        Svi: '',
        Attivo: 'none',
        }
  },

  persona: {
    fb: {
      Nome: '',
      Cognome: '',
      Matricola: 'none',
      Datanascita: 'none',
      Dataassunzione: 'none',
      Datalicenziamento: 'none',
      Sesso: 'none',
      Cittanascita: 'none',
      Provincianascita: 'none',
      Codicefiscale: '',
      Citta: 'none',
      Provincia: 'none',
      Residenza: 'none',
      Cap: 'none',
      Telefono: '',
      Tipopersona: 'none',
      Tipocontratto: 'none',
      Nazione: 'none',
      Pec: '',
      Nomesede: '',
      Mansione: 'none',
      Nomestruttura: '',
      Liberatoria: '',
      Dataliberatoria: '',
      Codice: 'none',
      documents: '',
      newdocument: '',
      stato: {
        stato_bozza: 'Bozza',
        stato_inviato: 'Inviato',
        stato_letto: 'Letto',
        stato_approvato: 'Approvato'
      }
    },
    orfri: {
      Nome: '',
      Cognome: '',
      Matricola: 'none',
      Datanascita: 'none',
      Dataassunzione: 'none',
      Datalicenziamento: 'none',
      Sesso: 'none',
      Cittanascita: 'none',
      Provincianascita: 'none',
      Codicefiscale: '',
      Citta: 'none',
      Provincia: 'none',
      Residenza: 'none',
      Cap: 'none',
      Telefono: '',
      Tipopersona: 'none',
      Tipocontratto: 'none',
      Nazione: 'none',
      Pec: '',
      Nomesede: 'none',
      Mansione: 'none',
      Nomestruttura: 'none',
      Liberatoria:'',
      Dataliberatoria: '', 
      Codice: 'none',
      documents: 'none',
      newdocument: 'none',
      stato: {
        stato_bozza: 'Bozza',
        stato_inviato: 'Inviato',
        stato_letto: 'Letto',
        stato_approvato: 'Approvato'
      }
    },
  },

  ruoliEnabledToload: {
    Amministratore: 'NO',
    Tutor: 'NP',
    Docente: 'YES',
    Allievo: 'NO',
    HR: 'YES',
    Dipendente: 'NO'
  },

  commessa: {
    Codice: 'none',
    Numerocommessa: '',
    Codiceazienda: 'none',
    Nomecliente: '',
    Dataingresso: '',
    Datafine: '',
    Marcaveicolo: '',
    Modelloveicolo: '',
    Targaveicolo: '',
    Telaioveicolo: '',
    Marcafrigo: '',
    Matricolafrigo: '',
    Modellofrigo: '',
    Annofabbricazionefrigo: '',
    Codicetipocommessa: 'none',
    Nometipocommessa: '',
    Note: 'none',
    Noteofficina: 'none',
    Stato: '',
    Assegnatario: '',
    Tot:'',
    Eng:'',
    Ele:'',
    Km:'',
  },
  addcommessa: {
    Codice: 'none',
    Numerocommessa: '',
    Codiceazienda: 'none',
    Nomecliente: '',
    selectedValueStato:'',
    Dataingresso: '',
    Datafine: '',
    Marcaveicolo: '',
    Modelloveicolo: '',
    Targaveicolo: '',
    Telaioveicolo: '',
    Marcafrigo: '',
    Matricolafrigo: '',
    Modellofrigo: '',
    Annofabbricazionefrigo: '',
    Codicetipocommessa: 'none',
    Nometipocommessa: '',
    Note: '',
    Noteofficina: '',
    Persona: '',
    Tot:'',
    Eng:'',
    Ele:'',
    Km:'',
  },
   addnotacommessa: {
    Codice: 'none',
    Noteamministrazione: '',
  },
  lavorazione: {
    Codice: 'none',
    Nome: '',
    Stato: '',
    Quantita: '',
    Tipolavorazione: '',
  },
  addlavorazione: {
    Codice: 'none',
    Nome: '',
    Stato: '',
    Codicecommessa: 'none',
    Codicestatolavorazione: 'none',
    Codicetipolavorazione: 'none',
    Importo: '',
    Sconto: '',
    Subtotale: '',
    Quantita: '',
    Tipolavorazione: '',
  },
    addlavorazionedialog: {
    Codice: 'none',
    Nome: '',
    Stato: '',
    Codicecommessa: 'none',
    Codicestatolavorazione: 'none',
    Codicetipolavorazione: 'none',
    Importo: '',
    Sconto: 'none',
    Subtotale: 'none',
    Quantita: '',
    Tipolavorazione: '',
  },
    addmanodopera: {
    Codice: 'none',
    Nome: '',
    Stato: '',
    Codicecommessa: 'none',
    Codicestatolavorazione: 'none',
    Importo: '',
    Sconto: '',
    Subtotale: '',
    Quantita: '',
    Tipolavorazione: '',
  },
  catalogo: {
    Codice: 'none',
    Nome: '',
    Descrizione: '',
    Datavalidodal: '',
    Datavalidoal: '',
    Categoria: 'none',
    Codicefornitore: 'none',
  },
  addcatalogo: {
    Codice: 'none',
    Nome: '',
    Descrizione: '',
    Datavalidodal: '',
    Datavalidoal: '',
    Categoria: 'none',
    Codicefornitore: 'none',
  },
  articolo: {
    Id: 'none',
    Catalogo: 'none',
    Codicecatalogo: 'none',
    Codicearticolo: '',
    Descrizione: '',
    Categoria: 'none',
    Unitamisura: '',
    Prezzo: '',
    Note: 'none',
    Giacenza: '',
    Costo: '',
    Iva: '',
  },
  addarticolo: {
    Id: 'none',
    Catalogo: 'none',
    Codicecatalogo: 'none',
    Codicearticolo: '',
    Descrizione: '',
    Categoria: '',
    Unitamisura: '',
    Prezzo: '',
    Note: '',
    Giacenza: '',
    Costo: '',
    Iva: '',
  },

};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
